var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTippingHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.587 74.486V69.33c0-6.104 6.12-11 12.222-11 7.333 6.111 14.666 6.111 22 0 1.672 0 3.816-.34 5.364.319a14.516 14.516 0 013.956 3.437v12.4",
    fill: "#C3E9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.287 37.87c0 11 6.033 17.112 13.444 17.112 7.256 0 13.522-6.111 13.522-17.111.03-2.1-.386-4.184-1.222-6.111-3.667-3.667-8.556-9.778-8.556-9.778-4.888 3.666-8.555 7.333-15.888 8.555 0 0-1.3 1.222-1.3 7.334zM67.142 74.486l-2.368-17.433 1.146-1.528 7.333-2.445 6.111-7.333a1.73 1.73 0 00-2.444-2.444l-3.667 3.666c-1.222 1.222-4.889 0-8.555 1.222-3.667 1.223-6.111 3.951-6.111 6.112v20.183",
    fill: "#FFD6C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.213 31.872c-3.253-1.046-9.004-9.7-9.004-9.7-3.253 3.95-15.567 8.538-15.567 8.538-3.66 3.66-.055 16.938-.055 16.938-4.89 0-4.89-7.333-4.89-15.889 0-8.555 4.89-17.11 17.112-17.11 12.222 0 17.11 8.555 17.11 17.11 0 8.556 0 15.89-4.888 15.89 1.62-2.754.182-15.777.182-15.777z",
    fill: "#FFCF52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.587 47.648c-4.89 0-4.89-7.333-4.89-15.889 0-8.555 4.89-17.11 17.112-17.11 12.222 0 17.11 8.555 17.11 17.11 0 8.556 0 15.89-4.888 15.89M14.587 73.315v-3.667c0-6.103 6.12-11 12.222-11 7.333 6.111 14.666 6.111 22 0 1.683.011 3.347.36 4.892 1.027",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.487 36.648a1.944 1.944 0 11-3.889 0 1.944 1.944 0 013.889 0zM34.71 36.648a1.945 1.945 0 11-3.89 0 1.945 1.945 0 013.89 0z",
    fill: "#2D2F33",
    stroke: "#2D2F33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.287 37.87c0 11 6.033 17.112 13.444 17.112 7.256 0 13.522-6.111 13.522-17.111.03-2.101-.386-4.184-1.222-6.112-3.667-3.666-8.556-9.777-8.556-9.777-4.888 3.666-8.555 7.333-15.888 8.555 0 0-1.3 1.222-1.3 7.334z",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.142 46.426a8.01 8.01 0 007.333 0M67.142 73.315l-2.368-16.262 1.146-1.528 7.333-2.445 6.111-7.333a1.729 1.729 0 10-2.444-2.444l-3.667 3.666c-1.222 1.222-4.889 0-8.555 1.222-3.667 1.223-6.111 3.951-6.111 6.112v19.012",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTippingHand;